import React from 'react';
import GlobalOtp from '../../common/components/GlobalOTp/GlobalOTP';
import BpVerified from '../../common/components/BPVerified/BPVerified';
import { resendOtp, confirmOtp } from '../../common/constants/api';
import { setToken } from '../../common/utils/auth-utils';
import { setAcl } from '../../common/utils/acl-utils';
import config from '../../../data/SiteConfig';

const Steps = [
  {
    id: 'otp',
    component: () => (
      <GlobalOtp
        itsBpOnBoarding
        header={
          <p
            className=""
            style={{
              color: '#8295A7'
            }}
          >
            Enter the OTP you received to
          </p>
        }
        consumerSendOtp={resendOtp}
      />
    ),
    initialValues: {
      otp: ''
    },
    onAction: async (sectionValues, formValues) => {
      await confirmOtp({
        phone: sectionValues?.mobile,
        mobileOtp: sectionValues?.otp,
        email: sectionValues?.email,
        emailOtp: ''
      })
        .then(async res => {})
        .catch(err => {
          throw new Error();
        });
    }
  },

  {
    id: 'bPVerified',
    component: BpVerified
  }
];
export default Steps;
